import React from 'react';
import { connect } from 'react-redux';
import { currencyFormatter } from 'utils/formatter';
import styles from './style.css';

class FilteredReport extends React.Component {
  render() {
    const { report } = this.props;
    return (
      <tr className={styles.row}>
        <td className={styles.name}>{report.cancelledTime}</td>
        <td className={styles.name}>{report.orderId}</td>
        <td className={styles.name}>{report.itemName}</td>
        <td className={styles.name}>{report.itemCount}</td>
        <td className={styles.name}>{report.cancelledReason}</td>
        <td className={styles.name}>{report.cancelledByName}</td>
        <td className={styles.name}>
          {currencyFormatter(report.itemTotalPrice)}
        </td>
      </tr>
    );
  }
}
function mapStateToProps(state) {
  return {
    voidItem: state.tableManagement.voidItem,
  };
}

export default connect(mapStateToProps)(FilteredReport);
